<template>
  <div class="app-shell">
    <SiteHeader />

    <main class="app-main">
      <div class="container">
        <router-view />
      </div>
    </main>

    <SiteFooter />
  </div>
</template>

<script setup>
import SiteHeader from "./components/SiteHeader.vue";
import SiteFooter from "./components/SiteFooter.vue";
</script>